export default __webpack_public_path__ + "static/bg-company-7dc5cba4b40342c06a6999fae7e7e67a.jpeg";